<form class="default-main" [formGroup]="form" (submit)="selectDefaultPage($event)">
    <h1 class="title-h1">
        <svg-image name="appodeal-new-logo" class="default-main__logo"></svg-image>
        {{ 'analytics.defaultMain.title' | i18next }}
    </h1>
    <p class="title-h2">{{ 'analytics.defaultMain.text' | i18next }}</p>
    <div class="default-main__more">
        <a href="#">{{ 'common.learnMore' | i18next }}</a>
    </div>
    <div class="default-main__list">
        <div class="default-main__item">
            <input
                type="radio"
                name="isDefaultMainPage"
                [value]="DefaultMainPage.MONETIZATION"
                id="classic"
                class="hidden"
                formControlName="isDefaultMainPage"
            />
            <label for="classic">
                <p class="title-h2">{{ 'dashboard.tabs.monetization' | i18next }}</p>
                <div class="default-main__img">
                    <i class="icn--check-thin"></i>
                    <img src="/assets/images/default-main-page/item-1.png" alt="" />
                </div>
                <p class="txt-sm">{{ 'analytics.defaultMain.list.description1' | i18next }}</p>
            </label>
        </div>

        <div class="default-main__item">
            <input
                type="radio"
                name="isDefaultMainPage"
                [value]="DefaultMainPage.OVERVIEW"
                id="overview"
                class="hidden"
                formControlName="isDefaultMainPage"
            />
            <label for="overview">
                <p class="title-h2">{{ 'dashboard.tabs.overview' | i18next }}</p>
                <div class="default-main__img">
                    <i class="icn--check-thin"></i>
                    <img src="/assets/images/default-main-page/item-2.png" alt="" />
                </div>
                <p class="txt-sm">{{ 'analytics.defaultMain.list.description2' | i18next }}</p>
            </label>
        </div>
        <div class="default-main__item">
            <input
                type="radio"
                name="isDefaultMainPage"
                [value]="DefaultMainPage.REPORTS"
                id="reports"
                class="hidden"
                formControlName="isDefaultMainPage"
            />
            <label for="reports">
                <p class="title-h2">{{ 'dashboard.tabs.reports' | i18next }}</p>
                <div class="default-main__img">
                    <i class="icn--check-thin"></i>
                    <img src="/assets/images/default-main-page/item-3.png" alt="" />
                </div>
                <p class="txt-sm">{{ 'analytics.defaultMain.list.description3' | i18next }}</p>
            </label>
        </div>
    </div>
    <button class="button default-main__btn" [class.loading]="formService.pending$ | async">{{ 'common.btn.save' | i18next }}</button>
</form>
